













































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';

@Component
export default class OrderDetailsProduct extends Vue {
  @Prop() product: any;
  @Prop({default: false}) isMessage: boolean;
  
  @Emit() up() {
    return null;
  };
  
  @Emit() down() {
    return null;
  };

  get isCompact() {
    return !this.$vuetify.breakpoint.xl;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }
}
